export enum ComissionType {
  A = 'A',
  M = 'M',
}
